export const fetchAnnouncementsTypes = [
  'FETCH_ANNOUNCEMENTS',
  'FETCH_ANNOUNCEMENTS_SUCCESS',
  'FETCH_ANNOUNCEMENTS_FAIL',
];

export const sendAnnouncementTypes = [
  'SEND_ANNOUNCEMENT',
  'SEND_ANNOUNCEMENT_SUCCESS',
  'SEND_ANNOUNCEMENT_FAIL',
];



// WEBPACK FOOTER //
// ./src/modules/announcement/action_types.js